import { useQuery } from 'react-query';
import { queryGet } from './fetch';

export enum ActionCausedByRole {
  ADMIN = 'ADMIN',
  CLIENT = 'CLIENT',
  PARTICIPANT = 'PARTICIPANT',
  AUTOMATIC = 'AUTOMATIC',
  ANONYMOUS_USER = 'ANONYMOUS_USER',
}

export interface ActionCausedBy {
  role: ActionCausedByRole;
  accountId?: string;
  participantId?: string;
  triggerEventName?: string;
}

export interface HistoryEvent {
  id: string;
  date: Date;
  eventName: string;
  actionCausedBy: ActionCausedBy;
  metadata: any;
  category: string;
}

export interface ParticipationHistoryEvent extends HistoryEvent {
  participationId?: string;
  applicationId?: string;
  formResponseId?: string;
  taskId?: string;
  orderId?: string;
  incentivePaymentId?: string;
}

export interface StudyHistoryEvent extends HistoryEvent {
  sessionId: string;
}

export const useParticipationHistoryEvents = (participationId?: string) => {
  return useQuery<ParticipationHistoryEvent[]>(
    ['participations', participationId, 'history-events'],
    queryGet(`/participations/${participationId}/history-events`),
    {
      enabled: !!participationId,
    },
  );
};

export const useGetSessionHistory = (id?: string) => {
  return useQuery<StudyHistoryEvent[]>(
    ['sessions', id, 'history'],
    queryGet(`/sessions/${id}/history`),
  );
};
